import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, ResetPage } from "@insite/client-framework/Store/Pages/ProductList/Handlers/AddProductFilters";

replaceInChain(chain, ResetPage, props => {
    if (
        props.parameter.pageSize ||
        props.parameter.sort ||
        props.parameter.pageCategoryId ||
        /* Valtech Custom Code */
        props.parameter.stockedItemsOnly ||
        props.parameter.previouslyPurchasedProducts ||
        /* Valtech Custom Code */
        props.parameter.searchWithinQueries?.length ||
        props.parameter.brandIds?.length ||
        props.parameter.productLineIds?.length ||
        props.parameter.priceFilters?.length ||
        props.parameter.attributeValueIds?.length ||
        props.parameter.categoryId
    ) {
        props.result.page = undefined;
    }
});
